import { FormattedMessage, useIntl } from "react-intl";

import { Text } from "@/components/atoms/Text";
import CocktailBarIcon from "@/icons/__generated__/CocktailBar/CocktailBar20";
import CreditCardIcon from "@/icons/__generated__/CreditCard/CreditCard20";
import ExperiencesIcon from "@/icons/__generated__/Experiences/Experiences20";
import ExtraSpaceIcon from "@/icons/__generated__/ExtraSpace/ExtraSpace20";
import GroupIcon from "@/icons/__generated__/Group/Group20";
import UtensilsIcon from "@/icons/__generated__/Utensils/Utensils20";
import { useListingData } from "~/context/ListingPageDataContext";

import {
  getDrinkOptionMessage,
  getFoodOptionMessage,
} from "../../utils/fsv.utils";

export const FsvDetailsSection = () => {
  const { data: listingData } = useListingData();
  const { fullService, listingMinimumDuration } = listingData || {};
  const intl = useIntl();

  const foodMessage = getFoodOptionMessage(
    fullService?.food_packages?.[0],
    intl,
  );

  const drinkMessage = getDrinkOptionMessage(fullService?.drink_options, intl);

  return (
    <div className="tw-flex tw-gap-8 md:tw-flex-row tw-flex-col">
      <div className="tw-flex-1 tw-flex tw-flex-col tw-gap-8">
        <div className="tw-flex tw-gap-8">
          <ExtraSpaceIcon className="tw-basis-20 tw-h-24" />
          <Text className="tw-flex-1">
            <FormattedMessage
              defaultMessage="Reserved for {totalHours} hours"
              values={{
                totalHours: listingMinimumDuration,
              }}
            />
          </Text>
        </div>

        <div className="tw-flex tw-gap-8">
          <CreditCardIcon className="tw-basis-20 tw-h-24" />
          <Text className="tw-flex-1">
            {fullService?.is_drinking_age_restricted ? (
              <FormattedMessage defaultMessage="Drinking age restricted" />
            ) : (
              <FormattedMessage defaultMessage="No age restriction" />
            )}
          </Text>
        </div>

        <div className="tw-flex tw-gap-8">
          <GroupIcon className="tw-basis-20 tw-h-24" />
          <Text className="tw-flex-1">
            <FormattedMessage defaultMessage="Staffing and cleaning included" />
          </Text>
        </div>
      </div>

      <div className="tw-flex-1 tw-flex tw-flex-col tw-gap-8">
        {foodMessage && (
          <div className="tw-flex tw-gap-8">
            <UtensilsIcon className="tw-basis-20 tw-h-24" />
            <Text className="tw-flex-1">{foodMessage}</Text>
          </div>
        )}

        {drinkMessage && (
          <div className="tw-flex tw-gap-8">
            <CocktailBarIcon className="tw-basis-20 tw-h-24" />
            <Text className="tw-flex-1">{drinkMessage}</Text>
          </div>
        )}

        <div className="tw-flex tw-gap-8">
          <ExperiencesIcon className="tw-basis-20 tw-h-24" />
          <Text className="tw-flex-1">
            <FormattedMessage defaultMessage="After reserving, team up with the host to choose your menu items" />
          </Text>
        </div>
      </div>
    </div>
  );
};
